// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconStyledForChips_icon__1xxwx","avatar":"IconStyledForChips_avatar__1lGHv"};